import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { environment } from '../../../../../../environments/environment';


@Component({
  selector: 'app-update-upload-documents-list',
  templateUrl: './update-upload-documents-list.component.html',
  styleUrl: './update-upload-documents-list.component.css'
})
export class UpdateUploadDocumentsListComponent {

  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private apiService: ApiService,
    private router: Router,
    private toastrService: ToastrService,
    public commonService: CommonService
  ) { }

  dataSource: any[] = [];

  totalRecords: number = 0;

  searchText: string = '';

  pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedOn',
    sortDirection: 'DESC'
  };

  searchTimeout: any;

  ngOnInit() {

    this.loadData();

  }

  // Load Data

  loadData() {

    this.pagination.searchTerm = this.searchText;

    this.apiService
      .getRequest(
        API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST,
        this.pagination
      )
      .subscribe({

        next: (res: any) => {

          console.log('API RESPONSE:', res);

          if (res && (res.status || res.Status)) {

            this.dataSource =
              res.data ||
              res.Data ||
              res.items ||
              res.Items ||
              [];

            this.totalRecords =
              res.totalRecords ||
              res.TotalRecords ||
              res.recordsFiltered ||
              0;

            console.log('TABLE DATA:', this.dataSource);

          }
          else {

            this.dataSource = [];
            this.totalRecords = 0;

          }

        },

        error: (err) => {

          console.error(err);

          this.dataSource = [];
          this.totalRecords = 0;

        }

      });

  }

  // Pagination

  onPageChange(event: any) {

    this.pagination.pageNumber = event.pageIndex + 1;

    this.pagination.pageSize = event.pageSize;

    this.loadData();

  }

  // Sorting

  sort(column: string) {

    if (this.pagination.sortColumn === column) {

      this.pagination.sortDirection =
        this.pagination.sortDirection === 'ASC'
          ? 'DESC'
          : 'ASC';

    }
    else {

      this.pagination.sortColumn = column;

      this.pagination.sortDirection = 'ASC';

    }

    this.pagination.pageNumber = 1;

    this.loadData();

  }

  // Search

  onSearchChange(value: string) {

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {

      this.pagination.searchTerm = value;

      this.pagination.pageNumber = 1;

      this.loadData();

    }, 500);

  }

  // Upload Documents Navigation

  onUploadDocuments() {

    this.router.navigate(['/Update-Upload-Documents']);

  }

  // Reset

  resetFilters() {
    // 🟢 १. दोन्ही सर्च व्हेरिएबल्स पूर्णपणे रिकामे (Clear) करणे
    this.searchText = '';

    this.pagination = {
      pageNumber: 1,
      pageSize: 10,
      searchTerm: '', // 🟢 २. एपीआयला जाणारा टर्म रिकामा करणे
      sortColumn: 'CreatedOn',
      sortDirection: 'DESC'
    };

    console.log('Filters reset successfully. Reloading full data...');
    this.loadData(); // ३. पूर्ण डेटा पुन्हा फ्रेश लोड करणे
  }

  // Download

  // Download File Fix (TS2341 Error Resolved)
  // Download File Fix (TS2551 Spelling Error Resolved)
  downloadFile(row: any) {
    console.log('Main Screen Row Data:', row);

    const rawPath = row.RelativePath || row.relativePath || row.FilePath || row.filePath;

    if (!rawPath) {
      console.warn('File path is missing on main screen row:', row);
      this.toastrService.warning('File path is not available.');
      return;
    }

    const cleanPath = rawPath.replace(/\\/g, '/');
    const fileName = row.OriginalFileName || row.originalFileName || row.DocumentName || row.documentName || 'download.pdf';

    console.log('Initiating download from main list for path:', cleanPath);

    this.apiService.downloadFile(cleanPath).subscribe({
      next: (blob: Blob) => {
        if (blob) {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } else {
          this.toastrService.error('Could not generate download file link.');
        }
      },
      error: (err) => {
        console.error('Download error on main screen:', err);

        try {
          // 🟢 मुख्य फिक्स: 'environment.apiUrl' ऐवजी अचूक स्पेलिंग 'environment.api_url' वापरले आहे
          const baseUrl = environment.api_url || environment.apiBaseUrl || '';
          const fallbackUrl = `${baseUrl}/${cleanPath}`;
          window.open(fallbackUrl, '_blank');
        } catch (e) {
          try {
            window.open(cleanPath, '_blank');
          } catch (innerUrlErr) {
            this.toastrService.error('Failed to download file from server.');
          }
        }
      }
    });
  }

}
